export default __webpack_public_path__ + "media/images/jqueryui/ui-icons_ffffff_256x240-f343f4f9ff29853595fb82699f73863c.png";